import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import DataGrid, { Column, HeaderFilter, Paging, Pager, MasterDetail } from "devextreme-react/ui/data-grid";
import { Button } from "devextreme-react";
import HeaderTooltip from "../../../../../Shared/headerTooltip";
import validaciones from "../../../../../../helpers/validaciones";

const ActionButton = (props) => (
  <Button
    type={props.type}
    disabled={props.disabled}
    text={props.text}
    onClick={props.onClick}
    style={props.style}
    render={(btn) => (
      <div
        style={{
          padding: "7px 0px 0px 0px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {btn.text}
      </div>
    )}
  />
);

const TableDetails = (props) => (
  <div style={{ textAlign: "left" }}>
    <span style={{ fontSize: 18 }}>
      Periodos de pago
    </span>
    <DataGrid
      className="simpleHeader height-min cursor-disabled"
      showBorders={false}
      showColumnLines={false}
      renderAsync
      showRowLines={false}
      noDataText=""
      dataSource={props.source.data.PeriodoPagos}
      onContentReady={(e) => {
        if (e.component.totalCount() === 0) {
          const config = {};
          config.addClass = "table-margin";
          const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
          const element = validaciones.noDataDOMElement(config, "Sin períodos de pago");
          noDataSpan.appendChild(element);
        }
      }}
    >
      <Column dataField="FechaDesde" caption="Fecha desde" dataType="date" format="dd/MM/yyyy" />
      <Column dataField="FechaHasta" caption="Fecha hasta" dataType="date" format="dd/MM/yyyy" />
      <Column dataField="DiasPagados" caption="Días pagados" />
      <Column
        dataField="FechaPago"
        caption="Fecha de pago"
        sortIndex={0}
        sortOrder="desc"
        sortingMethod={(v1, v2) => {
          const v1d = moment(v1);
          const v2d = moment(v2);
          if (v1d.isAfter(v2d)) return 1;
          if (v1d.isSame(v2d)) return 0;
          if (v1d.isBefore(v2d)) return -1;
          return 0;
        }}
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column
        caption="Estado de pago"
        cellComponent={(row) => (
          <div>
            {row.data.EstadoPago || "S/D"}
          </div>
        )}
      />
      <Column
        dataField="Monto"
        caption="Monto"
        cellComponent={(row) => (
          <div>
            {`$ ${new Intl.NumberFormat("es-CL").format(row.data.Monto)}`}
          </div>
        )}
      />
      <Column dataField="FormaPago" caption="Forma de pago" />
      <Paging pageSize={10} enabled />
      <Pager showNavigationButtons showInfo infoText={(page, total) => `Página ${page} de ${total}`} />
    </DataGrid>
  </div>
);

class TablaPrestaciones extends React.PureComponent {
  handleOpenFile = (row) => {
    this.props.onViewDocument(row.data);
  }

  handleRowClick = (e) => {
    if (e.handled) {
      if (e.isExpanded) {
        e.component.collapseAll(-1);
        e.component.expandRow(e.key);
      } else {
        e.component.collapseRow(e.key);
      }
    } else if (!e.isExpanded) {
      e.component.collapseAll(-1);
      e.component.expandRow(e.key);
    } else {
      e.component.collapseRow(e.key);
    }
  }

  render() {
    return (
      <DataGrid
        dataSource={this.props.data}
        className="custom-table"
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        noDataText=""
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
            const element = validaciones.noDataDOMElement(config, "Sin prestaciones");
            noDataSpan.appendChild(element);
          }
        }}
        rowAlternationEnabled
        hoverStateEnabled
        selection={{
          mode: "single",
        }}
        onRowClick={this.handleRowClick}
      >
        <MasterDetail
          enabled
          template={(container, options) => ReactDOM.render(<TableDetails source={options} />, container)}
        />
        <HeaderFilter
          visible
          texts={{
            cancel: "Cancelar",
            emptyValue: "Sin valor",
            ok: "Aceptar",
          }}
        />
        <Column
          dataField={["IdPrestacion, TipoPrestacion"]}
          allowFiltering={false}
          caption="Prestación"
          cellComponent={(row) => (
            <div className="group-Column-Prestaciones">
              <div className={row.data.TipoPrestacion === "Subsidio Directo" ? "table-label-light-blue" : "table-label-green"}>
                {row.data.TipoPrestacion}
              </div>
              <div className="text spaceText" >{Number(row.data.IdPrestacion).toString()}</div>
            </div>
          )}
        />
        {/* <Column dataField="IdPrestacion" caption="ID" allowFiltering={false} /> */}
        <Column dataField="EstadoDocumentacion" caption="Estado documentación" allowFiltering={false} />
        <Column
          caption="Último Monto Pagado"
          dataField="UltimoMontoPagado"
          alignment="center"
          allowFiltering={false}
          cellComponent={(row) => (
            <div> {
              `$ ${new Intl.NumberFormat("es-CL").format(row.data.MontoUltimoPago)}`
            }
            </div>
          )}
          headerCellTemplate={(element, row) => {
            ReactDOM.render(<HeaderTooltip
              id="tooltipMonto"
              textFirst
              widthprops={200}
              headerText="Ultimo monto pagado"
              toolTipText="Valor del último monto pagado de la prestación económica"
            />, element);
          }}
        />
        <Column
          dataField="FechaUltimoPago"
          caption="Fecha último pago"
          dataType="date"
          format="dd/MM/yyyy"
          alignment="center"
          allowFiltering={false}
        />
        <Column
          caption="Liquidaciones de pago"
          allowFiltering={false}
          alignment="center"
          cellTemplate={(element, row) => {
            ReactDOM.render(
              <ActionButton
                text="Ver"
                onClick={() => this.handleOpenFile(row)}
                type="success"
              />
              , element
            );
          }}
        />
        <Paging pageSize={10} enabled />
        <Pager showNavigationButtons showInfo infoText={(page, total) => `Página ${page} de ${total}`} />
      </DataGrid>
    );
  }
}

export default TablaPrestaciones;
